import React, { useState, useEffect } from 'react';
import ProductTypesList from './ProductTypesList';
import ViewProductType from './ViewProductType';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './ProductTypes.css';

function ProductTypes() {
  const [selectedProductTypeId, setSelectedProductTypeId] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // 'list', 'view', 'edit', 'create'

  useEffect(() => {
    // Set toolbar based on current mode
    if (window.setToolbar) {
      if (viewMode === 'list') {
        window.setToolbar({
          title: 'Product Types',
          buttons: [
            {
              label: 'New Product Type',
              icon: '➕',
              onClick: handleNew,
              variant: 'primary'
            },
            {
              label: 'Refresh',
              icon: '🔄',
              onClick: handleRefresh
            }
          ]
        });
      } else if (viewMode === 'view') {
        window.setToolbar({
          title: 'View Product Type',
          showBack: true,
          onBack: handleBack,
          buttons: [
            {
              label: 'Edit',
              icon: '✏️',
              onClick: handleEdit,
              variant: 'secondary'
            },
            {
              label: 'Delete',
              icon: '🗑️',
              onClick: handleDelete,
              variant: 'danger'
            }
          ]
        });
      } else if (viewMode === 'edit') {
        window.setToolbar({
          title: 'Edit Product Type',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Save',
              icon: '💾',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      } else if (viewMode === 'create') {
        window.setToolbar({
          title: 'New Product Type',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Create',
              icon: '➕',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      }
    }

    return () => {
      if (window.setToolbar) {
        window.setToolbar(null);
      }
    };
  }, [viewMode]);

  const handleSelectProductType = (productTypeId) => {
    setSelectedProductTypeId(productTypeId);
    setViewMode('view');
  };

  const handleNew = () => {
    setSelectedProductTypeId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleDelete = () => {
    // Delete will be handled in ViewProductType component
    if (window.viewProductTypeRef && window.viewProductTypeRef.handleDelete) {
      window.viewProductTypeRef.handleDelete();
    }
  };

  const handleSave = () => {
    // Save will be handled in ViewProductType component
    if (window.viewProductTypeRef && window.viewProductTypeRef.handleSave) {
      window.viewProductTypeRef.handleSave();
    }
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedProductTypeId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleBack = () => {
    setViewMode('list');
    setSelectedProductTypeId(null);
  };

  const handleRefresh = () => {
    // Trigger refresh in ProductTypesList
    if (window.productTypesListRef && window.productTypesListRef.fetchProductTypes) {
      window.productTypesListRef.fetchProductTypes();
    }
  };

  const handleProductTypeSaved = (productType) => {
    setSelectedProductTypeId(productType.product_type_id);
    setViewMode('view');
    // Refresh the list
    if (window.productTypesListRef && window.productTypesListRef.fetchProductTypes) {
      window.productTypesListRef.fetchProductTypes();
    }
  };

  return (
    <div className="product-types-page">
      <ResizablePanels
        leftPanel={
          <ProductTypesList
            ref={ref => window.productTypesListRef = ref}
            onSelectProductType={handleSelectProductType}
            selectedProductTypeId={selectedProductTypeId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewProductType
              ref={ref => window.viewProductTypeRef = ref}
              productTypeId={selectedProductTypeId}
              onBack={handleBack}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onSave={handleProductTypeSaved}
              onCancel={handleCancel}
              onEdit={handleEdit}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
}

export default ProductTypes;